import React from 'react';
import styled from 'styled-components';
import useLocale from '../../hooks/useLocale';
import isHanumanDay from '../shared/utils/isHanumanDay';
import { HANUMAN_COLORS } from './hanumanColors';

const LandingBanner = styled.div`
  max-width: 640px;
  margin: ${p => p.theme.spacing[3]}px auto;
  padding: ${p => p.theme.spacing[3]}px ${p => p.theme.spacing[4]}px;
  background: linear-gradient(135deg, ${HANUMAN_COLORS.accent}, ${HANUMAN_COLORS.gold});
  color: #fff;
  border-radius: 8px;
  font-size: 14px;
  font-family: 'Noto Sans Tamil', ${p => p.theme.typography.fontFamily};
  font-weight: 500;
  text-align: center;
`;

const ResultRibbon = styled.div`
  display: inline-block;
  margin: 0 auto ${p => p.theme.spacing[3]}px;
  padding: 4px 12px;
  background: ${HANUMAN_COLORS.accent};
  color: #fff;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  font-family: 'Noto Sans Tamil', ${p => p.theme.typography.fontFamily};
`;

const HanumanSpecialDayBanner = ({ variant = 'landing', lang }) => {
  const t = useLocale(lang, 'hanumanPrashnavali');
  if (!isHanumanDay(new Date())) return null;

  if (variant === 'result') {
    return <ResultRibbon>{t.specialDayResult || "Hanuman's day reading"}</ResultRibbon>;
  }
  return (
    <LandingBanner>
      {t.specialDayLanding || 'Today is a Hanuman day — blessings are especially potent'}
    </LandingBanner>
  );
};

export default HanumanSpecialDayBanner;
